// extracted by mini-css-extract-plugin
module.exports = {"footer":"CardFooter_footer__4EGVJ","avatar":"CardFooter_avatar__12HeO","footerBadge":"CardFooter_footerBadge__2zDbZ"};